import React from 'react'

import classes from './EmployeeImage.scss'

import Image from '../../../../../../Image/Image'
import defaultProfile from '../../../../../../../assets/defaultprofile.jpg'

const employeeImage = ({ src, empName }) => {
  return (
    <Image
      src={src || defaultProfile}
      variant={'circle'}
      imgAlt={empName || 'empProfile'}
      className={classes.EmployeeImage}
    />
  )
}

export default employeeImage
